import { useIsFetching, useQueryClient } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';

export function useScrollToHashOnceSettled() {
  const queryClient = useQueryClient();
  const fetching = useIsFetching();
  const settled = useRef(false);

  useEffect(() => {
    // The rendered count misses the queries that children start in this same commit, so the client is asked directly.
    if (settled.current || queryClient.isFetching() > 0) {
      return;
    }

    settled.current = true;
    const id = window.location.hash.slice(1);
    if (id) {
      document.getElementById(id)?.scrollIntoView({ block: 'start' });
    }
  }, [fetching, queryClient]);
}
